import { render, staticRenderFns } from "./SpecialEvents.vue?vue&type=template&id=33e0fd92"
import script from "./SpecialEvents.vue?vue&type=script&lang=js"
export * from "./SpecialEvents.vue?vue&type=script&lang=js"
import style0 from "./SpecialEvents.vue?vue&type=style&index=0&id=33e0fd92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports